import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaSearch } from 'react-icons/fa';

const SpeedyOfficeSelector = ({
  selectedSiteId,
  setSelectedSiteId,
  sites,
  filteredSpeedy2Offices,
  selectedSpeedy2Office,
  setSelectedSpeedy2Office
}) => {
  const [siteDropdownOpen, setSiteDropdownOpen] = useState(false);
  const [officeDropdownOpen, setOfficeDropdownOpen] = useState(false);
  const [siteSearchTerm, setSiteSearchTerm] = useState('');
  const [officeSearchTerm, setOfficeSearchTerm] = useState('');
  
  // Filter sites based on search term
  const filteredSites = sites.filter(site => {
    const regionName = (site.region || '').toLowerCase();
    const searchTerm = siteSearchTerm.toLowerCase();
    
    return regionName.includes(searchTerm);
  });
  
  // Filter offices based on search term
  const searchFilteredOffices = filteredSpeedy2Offices.filter(office => {
    const officeAddress = (office.fullAddr || '').toLowerCase();
    const searchTerm = officeSearchTerm.toLowerCase();
    
    return officeAddress.includes(searchTerm);
  });
  
  // Reset search terms when dropdowns close
  useEffect(() => {
    if (!siteDropdownOpen) setSiteSearchTerm('');
    if (!officeDropdownOpen) setOfficeSearchTerm('');
  }, [siteDropdownOpen, officeDropdownOpen]);

  return (
    <div className="mt-2">
      <div className="flex items-center mb-3">
        <FaMapMarkerAlt className="text-amber-500 mr-2" />
        <span className="font-medium text-sm">ИЗБЕРИ ОФИС</span>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="relative">
          <input
            type="text"
            placeholder="Населено място"
            value={selectedSiteId ? sites.find(s => s.id === selectedSiteId)?.region || '' : ''}
            onClick={() => setSiteDropdownOpen(true)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary cursor-pointer"
            readOnly
          />
          {siteDropdownOpen && (
            <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
              <div className="sticky top-0 bg-white p-2 border-b">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Търси населено място..."
                    value={siteSearchTerm}
                    onChange={(e) => setSiteSearchTerm(e.target.value)}
                    className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                    onClick={(e) => e.stopPropagation()}
                    autoFocus
                  />
                </div>
              </div>
              
              {filteredSites.length === 0 ? (
                <div className="px-4 py-3 text-gray-500 text-center">Няма намерени резултати</div>
              ) : (
                filteredSites.map(site => (
                  <div 
                    key={site.id} 
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedSiteId(site.id);
                      setSelectedSpeedy2Office(null);
                      setSiteDropdownOpen(false);
                    }}
                  >
                    {site.region}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            placeholder="Избери офис"
            value={selectedSpeedy2Office ? selectedSpeedy2Office.fullAddr : ''}
            onClick={() => selectedSiteId && setOfficeDropdownOpen(true)}
            className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary ${selectedSiteId ? 'cursor-pointer' : 'cursor-not-allowed bg-gray-50'}`}
            readOnly
            disabled={!selectedSiteId}
          />
          {officeDropdownOpen && selectedSiteId && (
            <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
              <div className="sticky top-0 bg-white p-2 border-b">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Търси офис..."
                    value={officeSearchTerm}
                    onChange={(e) => setOfficeSearchTerm(e.target.value)}
                    className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                    onClick={(e) => e.stopPropagation()}
                    autoFocus
                  />
                </div>
              </div>
              
              {searchFilteredOffices.length === 0 ? (
                <div className="px-4 py-3 text-gray-500 text-center">Няма намерени офиси</div>
              ) : (
                searchFilteredOffices.map(office => (
                  <div 
                    key={office.id} 
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedSpeedy2Office(office);
                      setOfficeDropdownOpen(false);
                    }}
                  >
                    {office.fullAddr}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpeedyOfficeSelector; 